export const AdvancedSearch = {
  footer: {
    id: 'div-gpt-ad-1500408352760-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_FlightTrackerAdvancedSearch_bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1500408413552-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_FlightTrackerAdvancedSearch_bottom_320x100',
  },
};
export const AirportCurrentConditions = {
  footer: {
    id: 'div-gpt-ad-1470845383089-2',
    sizes: [728, 90],
    adSlot: '/1010197/BS_AirportConditions_bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1470934182836-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_AirportConditions_bottom_320x100',
  },
};
export const AirportDelayMap = {
  footer: {
    id: 'div-gpt-ad-1470845645868-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_AirportDelays_bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1470934182836-1',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_AirportDelay_bottom_320x100',
  },
};
export const AirportSearch = {
  footer: {
    id: 'div-gpt-ad-1500402313575-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_AirportConditionsSearch_bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1500402396077-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_AirportConditionsSearch_bottom_320x100',
  },
};
export const CreateAccountContainer = {
  footer: {
    id: 'div-gpt-ad-1489619015062-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_Account_Bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1489619261605-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_Account_Bottom_320x100',
  },
};
export const DataExports = {
  footer: {
    id: 'div-gpt-ad-1494963203070-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_DataExports_bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1494961378134-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_DataExports_bottom_320x100',
  },
};
export const DataExportsHistoryDetail = {
  footer: {
    id: 'div-gpt-ad-1494963203070-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_DataExports_bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1494961378134-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_DataExports_bottom_320x100',
  },
};
export const DepartureArrivalSubscriptionMarketing = {
  footer: {
    id: 'div-gpt-ad-1489619015062-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_Account_Bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1489619261605-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_Account_Bottom_320x100',
  },
};
export const ExportsSearch = {
  footer: {
    id: 'div-gpt-ad-1494963203070-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_DataExports_bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1494961378134-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_DataExports_bottom_320x100',
  },
};
export const ExtendedDetails = {
  footer: {
    id: 'div-gpt-ad-1501016286376-2',
    sizes: [728, 90],
    adSlot: '/1010197/BS_FlightTrackerExtendedDetails_bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1501016286376-3',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_FlightTrackerExtendedDetails_bottom_320x100',
  },
};
export const FlightAlertsSubscriptionMarketing = {
  footer: {
    id: 'div-gpt-ad-1489619015062-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_Account_Bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1489619261605-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_Account_Bottom_320x100',
  },
};
export const FlightTracker = {
  footer: {
    id: 'div-gpt-ad-1470845574196-2',
    sizes: [728, 90],
    adSlot: '/1010197/BS_FlightTracker_bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1470934182836-3',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_FlightTracker_bottom_320x100',
  },
};
export const ForgotPassword = {
  footer: {
    id: 'div-gpt-ad-1489619015062-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_Account_Bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1489619261605-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_Account_Bottom_320x100',
  },
};
export const GlobalCancellationsDelays = {
  footer: {
    id: 'div-gpt-ad-1503353720593-2',
    sizes: [728, 90],
    adSlot: '/1010197/BS_GlobalCancellationsDelays_bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1503353720593-3',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_GlobalCancellationsDelays_bottom_320x100',
  },
};
export const HistoricalFlightSubscriptionMarketing = {
  footer: {
    id: 'div-gpt-ad-1489619015062-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_Account_Bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1489619261605-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_Account_Bottom_320x100',
  },
};
export const Homepage = {
  footer: {
    id: 'div-gpt-ad-1503432146362-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_Home_Bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1503432146362-1',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_Home_Bottom_320x100',
  },
};
export const Login = {
  footer: {
    id: 'div-gpt-ad-1489619015062-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_Account_Bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1489619261605-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_Account_Bottom_320x100',
  },
};
export const MonthlyPerformanceReportsAirlines = {
  footer: {
    id: 'div-gpt-ad-1503353229329-1',
    sizes: [728, 90],
    adSlot: '/1010197/BS_AirlineMonthlyPerformanceReport_bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1503353229329-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_AirlineMonthlyPerformanceReport_bottom_320x100',
  },
};
export const MonthlyPerformanceReportsAirports = {
  footer: {
    id: 'div-gpt-ad-1503353387500-1',
    sizes: [728, 90],
    adSlot: '/1010197/BS_AirportMonthlyPerformanceReport_bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1503353387500-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_AirportMonthlyPerformanceReport_bottom_320x100',
  },
};
export const MultiFlight = {
  footer: {
    id: 'div-gpt-ad-1500411822710-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_FlightTrackerFlightPicker_bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1500411994336-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_FlightTrackerFlightPicker_bottom_320x100',
  },
};
export const MyAccount = {
  footer: {
    id: 'div-gpt-ad-1489619015062-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_Account_Bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1489619261605-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_Account_Bottom_320x100',
  },
};
export const NewDataExports = {
  footer: {
    id: 'div-gpt-ad-1494963203070-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_DataExports_bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1494961378134-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_DataExports_bottom_320x100',
  },
};
export const OnTimePerformance = {
  footer: {
    id: 'div-gpt-ad-1502743031520-1',
    sizes: [728, 90],
    adSlot: '/1010197/BS_FlightOntimePerformance_bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1502743031520-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_FlightOntimePerformance_bottom_320x100',
  },
};
export const PlanSelection = {
  footer: {
    id: 'div-gpt-ad-1489619015062-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_Account_Bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1489619261605-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_Account_Bottom_320x100',
  },
};
export const PurchaseData = {
  footer: {
    id: 'div-gpt-ad-1494963203070-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_DataExports_bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1494961378134-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_DataExports_bottom_320x100',
  },
};
export const RegistrationBillingInformation = {
  footer: {
    id: 'div-gpt-ad-1489619015062-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_Account_Bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1489619261605-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_Account_Bottom_320x100',
  },
};
export const RegistrationCompletion = {
  footer: {
    id: 'div-gpt-ad-1489619015062-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_Account_Bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1489619261605-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_Account_Bottom_320x100',
  },
};
export const SignUpPreferences = {
  footer: {
    id: 'div-gpt-ad-1489619015062-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_Account_Bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1489619261605-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_Account_Bottom_320x100',
  },
};
export const Subscribe = {
  footer: {
    id: 'div-gpt-ad-1489619015062-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_Account_Bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1489619261605-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_Account_Bottom_320x100',
  },
};
export const SubscriptionMarketing = {
  footer: {
    id: 'div-gpt-ad-1489619015062-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_Account_Bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1489619261605-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_Account_Bottom_320x100',
  },
};
export const VerifyEmail = {
  footer: {
    id: 'div-gpt-ad-1489619015062-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_Account_Bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1489619261605-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_Account_Bottom_320x100',
  },
};
export const ViewPaymentHistoryDetail = {
  footer: {
    id: 'div-gpt-ad-1489619015062-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_Account_Bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1489619261605-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_Account_Bottom_320x100',
  },
};
export const UnifiedSearch = {
  footer: {
    id: 'div-gpt-ad-1500407896904-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_FlightTrackerSearch_bottom_728x90',
  },
  footerMobile: {
    id: 'div-gpt-ad-1500407738125-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_FlightTrackerSearch_bottom_320x100',
  },
};



// WEBPACK FOOTER //
// ./modules/App/ads.js